export default "__VITE_ASSET__l0Ryoq0H__"